import { type QueryHookOptions, useQuery } from "@apollo/client";
import { LanguagesQuery } from "../graphql/queries";
import type {
  LanguagesQueryType,
  LanguagesQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useLanguagesQuery = (
  options?: QueryHookOptions<LanguagesQueryType, LanguagesQueryVariablesType>
) => {
  return useQuery<LanguagesQueryType, LanguagesQueryVariablesType>(
    LanguagesQuery,
    options
  );
};
